import { getEndpoint } from '../../apiConstants';
import { API_ENDPOINTS } from '../../apiConstants';
import { ScriptTesterPayload, ScriptTesterData } from './scriptTester.types';

// Transform API response to clean UI data
const transformScriptTester = (response: string, functionCode: string, holder: string, myCode: string): ScriptTesterData => {
  // Handle both success and error responses
  let result = '';
  let isSuccess = true;
  let errorMessage = '';

  if (response.includes('Cannot invoke') || response.includes('error')) {
    // Backend returned an error
    result = '';
    isSuccess = false;
    errorMessage = response;
  } else {
    // Backend returned successful result
    result = response;
    isSuccess = true;
    errorMessage = '';
  }

  return {
    functionCode,
    holder,
    myCode,
    result,
    isSuccess,
    errorMessage
  };
};

// Script Tester API
export const scriptTesterApi = {
  test: async ({ 
    clientCode, 
    payload 
  }: { 
    clientCode: string; 
    payload: ScriptTesterPayload 
  }): Promise<ScriptTesterData> => {
    try {
      const endpoint = getEndpoint(clientCode, API_ENDPOINTS.ONLINE_TEMPLATE.SCRIPT_TEMPLATE);
      
      // Make direct fetch call to handle string response
      const token = localStorage.getItem("access_token");
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`/api/projectag${endpoint}`, {
        method: 'POST',
        headers,
        body: JSON.stringify([payload.functionCode, payload.holder, payload.myCode])
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      // Get response as text since backend returns plain string
      const responseText = await response.text();
      
      return transformScriptTester(responseText, payload.functionCode, payload.holder, payload.myCode);
    } catch (error) {
      return {
        functionCode: payload.functionCode,
        holder: payload.holder,
        myCode: payload.myCode,
        result: '',
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Failed to test script'
      };
    }
  }
};

// Legacy exports for backward compatibility
export const testScript = scriptTesterApi.test; 